import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  height: 100%;
  margin-right: 20px;
`;
